<template>
  <table class="table table-striped ">
    <thead class="border-top-0">
      <tr>
        <th>SKU</th>
        <th>Description</th>
        <th>Qty</th>
        <th>Alloc'd</th>
        <th>Ship'd</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in order.items" :key="item.id">
        <td>
          <router-link :to="`/products/${item.product.id}`">
            {{ item.product.sku }}
          </router-link>
          <i class="fas fa-boxes" v-if="item.product.kit"></i>
        </td>
        <td>{{ item.product.name }}</td>
        <td>{{ item.qty }}</td>
        <td>{{ item.qty_allocated || 0 }}</td>
        <td>{{ item.qty_shipped }}</td>
      </tr>
      <tr v-if="order.items.length == 0">
        <td colspan="4" class="text-center">No items for this order</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'items-tab',
  props: {
    order: Object,
  }
}
</script>